var page_function = page_scripts[$('section#primary').attr('class')];
if (typeof page_function === "object") {
    page_function.init();
}
